import React from "react";
import { useSlate } from "slate-react";
import { Icon, Button } from "@mui/material";

import { classes } from "../../styles";
import { feedback } from "../../../../events";
import { insertLink, isLinkActive, isUrl, unwrapLink } from "./linkButton";

interface IProps {
  disabled?: boolean;
}

export const LinkButton: React.FC<IProps> = ({ disabled = false }) => {
  const editor = useSlate();

  return (
    <Button
      size="small"
      variant="contained"
      disabled={disabled}
      disableElevation={!isLinkActive(editor)}
      color={!isLinkActive(editor) ? "primary" : "secondary"}
      sx={classes.button}
      onMouseDown={(event) => {
        event.preventDefault();

        const url = window.prompt("Insira a URL do link:");
        if (!url) return;

        if (isUrl(url)) {
          insertLink(editor, url);
        } else {
          feedback("URL inválida.", "error");
        }
      }}
    >
      <Icon fontSize="small" sx={classes.icon}>
        link
      </Icon>
    </Button>
  );
};

export const RemoveLinkButton: React.FC<IProps> = ({ disabled = false }) => {
  const editor = useSlate();

  return (
    <Button
      size="small"
      disabled={disabled}
      variant="contained"
      disableElevation={!isLinkActive(editor)}
      color={!isLinkActive(editor) ? "primary" : "secondary"}
      sx={classes.button}
      onMouseDown={(event) => {
        event.preventDefault();
        if (isLinkActive(editor)) {
          unwrapLink(editor);
        }
      }}
    >
      <Icon fontSize="small" sx={classes.icon}>
        link_off
      </Icon>
    </Button>
  );
};
